import FloatingHelp from "../floating-help/floating-help.component";
import "./help.styles.scss";

const Help = ({ showHelp, setShowHelp }) => {
  return (
    <div className="help-container">
      {showHelp && (
        <FloatingHelp showHelp={showHelp} setShowHelp={setShowHelp} />
      )}
    </div>
  );
};

export default Help;
